export function isFalsy<T>(value: T | null | undefined): value is T {
  return (
    value !== null && value !== undefined && value !== false && value !== ''
  );
}
